














































import { SdsButton } from '@superbet-group/web.lib.ui-components';
import {
    defineComponent,
    ref,
    PropType,
    watch,
    onUnmounted,
} from '@vue/composition-api';

import BetBuilderSummaryEventCard from '../shared/components/BetBuilderSummaryEventCard.vue';
import BetBuilderSummaryHeaderMobile from '../shared/components/BetBuilderSummaryHeaderMobile.vue';
import { BetBuilderPreviewSummary } from '../types/BetBuilderPreview';
import {
    ScrollDirection,
    useScrollDirection,
} from '@core/composables/useScrollDirection';

let collapseOnHideTimeout: ReturnType<typeof setTimeout>;

export default defineComponent({
    name: 'BetBuilderSummaryCompact',
    emits: [
        'create',
        'clear',
    ],
    props: {
        inactiveSelectionsCount: {
            type: Number,
            required: true,
        },
        isSelectionInactive: {
            type: Boolean,
            required: true,
        },
        summary: {
            type: Object as PropType<BetBuilderPreviewSummary>,
            required: true,
        },
        isCreateInProgress: {
            type: Boolean,
            required: true,
        },
        isPreviewLoading: {
            type: Boolean,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: true,
        },
    },
    setup(props) {
        const areSelectionsExpanded = ref(false);
        const isVisible = ref(true);

        const handleClickOutside = () => {
            _setExpandedState(false);
        };

        const _setExpandedState = (state?: boolean) => {
            clearTimeout(collapseOnHideTimeout);

            if (props.summary.legs.length <= 3) {
                areSelectionsExpanded.value = false;
                return;
            }

            if (state == null) {
                areSelectionsExpanded.value = !areSelectionsExpanded.value;
            } else {
                areSelectionsExpanded.value = state;
            }
        };

        const _setVisibilityState = (state?: boolean) => {
            if (state == null) {
                isVisible.value = !isVisible.value;
            } else {
                isVisible.value = state;
            }
        };

        useScrollDirection({
            scrollRecognitionLimit: 15,
            onScrollDirectionChange: ({ direction }) => {
                switch (direction) {
                    case ScrollDirection.UP:
                        _setVisibilityState(false);
                        break;
                    case ScrollDirection.DOWN:
                        _setVisibilityState(true);
                        break;
                }
            },
        });

        /**
         * When summary becomes not visible => collapse summary
         */
        watch(isVisible, (value) => {
            if (!value) {
                collapseOnHideTimeout = setTimeout(() => {
                    /**
                     * timeout duration is set to the summary visibility animation duration
                     *
                     * without the timeout, upon down scroll when expanded state the summary collapses first and
                     * then animates out which looks glitchy
                     */
                    _setExpandedState(false);
                }, 250);
            }
        });

        /**
         * When summary becomes expanded => show summary
         */
        watch(areSelectionsExpanded, (value) => {
            if (value) {
                _setVisibilityState(true);
            }
        });

        /**
         * When updating summary => show summary
         */
        watch(() => props.summary, () => {
            _setVisibilityState(true);
        });

        onUnmounted(() => {
            clearTimeout(collapseOnHideTimeout);
        });

        function toggleAllSelections() {
            _setExpandedState();
        }

        return {
            areSelectionsExpanded,
            isVisible,
            handleClickOutside,
            toggleAllSelections,
        };
    },
    components: {
        BetBuilderSummaryEventCard,
        BetBuilderSummaryHeaderMobile,
        SdsButton,
    },
});
